/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Экспресс отчёт от Контур.Фокус
 */
export interface BriefReport {
  /** Сводная информация из экспресс-отчета */
  summary?: Summary;

  /** Индивидуальная разовая ссылка на экспресс-отчет в Контур.Фокусе */
  href?: string;

  /** Индивидуальный номер налогоплательщика */
  inn?: string;

  /** Основной государственный регистрационный номер */
  orgn?: string;

  /** Полное наименование организации */
  fullName?: string;

  /** Сокращённое наименование организации */
  shortName?: string;
}

/**
 * Сводная информация из экспресс-отчета
 */
export interface Summary {
  /** Наличие информации, помеченной зеленым цветом */
  greenStatements?: boolean;

  /** Наличие информации, помеченной желтым цветом */
  yellowStatements?: boolean;

  /** Наличие информации, помеченной красным цветом */
  redStatements?: boolean;
}

export interface GetPrintReportParams {
  /** ИНН контрагента */
  inn: string;

  /** Флаг запроса из мобильного приложения */
  mobileApp?: boolean;

  /** Операционная система мобильного приложения */
  mobileOs?: string;

  /** Источник запроса:PAYMENT - создание/редактирование платежного документа PAYMENT_IMPORT - импорт платежных документовCONTRAGENTS - справочник контрагентовCUSTOM - произвольный поиск */
  requestFrom: "PAYMENT" | "PAYMENT_IMPORT" | "CONTRAGENTS" | "CUSTOM";
}

export interface GetBriefReportParams {
  /** ИНН контрагента */
  inn: string;

  /** Флаг запроса из мобильного приложения */
  mobileApp?: boolean;

  /** Операционная система мобильного приложения */
  mobileOs?: string;

  /** Источник запроса:PAYMENT - создание/редактирование платежного документа PAYMENT_IMPORT - импорт платежных документовCONTRAGENTS - справочник контрагентовCUSTOM - произвольный поиск */
  requestFrom: "PAYMENT" | "PAYMENT_IMPORT" | "CONTRAGENTS" | "CUSTOM";
}

import { HttpClient } from "../../client";
import { RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-rko-kf-adapter
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-rko-kf-adapter.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Запроса информации по контрагентам
     * @name GetPrintReport
     * @summary Получить печатную форму отчёт в файле по контрагенту из Контур.Фокуса
     * @request GET:/api/kf-adapter/external/v1/print-report
     * @secure
     */
    getPrintReport: (query: GetPrintReportParams, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/kf-adapter/external/v1/print-report`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Клиентский сервис
     * @name CorrespondentCheckServiceState
     * @summary Получить информацию по подключению услуги проверки контрагента для клиента
     * @request GET:/api/kf-adapter/external/v1/client/correspondent-check-service-state
     * @secure
     */
    correspondentCheckServiceState: (params: RequestParams = {}) =>
      this.request<boolean, ErrorMessage>({
        path: `/api/kf-adapter/external/v1/client/correspondent-check-service-state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Запроса информации по контрагентам
     * @name GetBriefReport
     * @summary Получить экспресс отчёт по контрагенту из Контур.Фокуса
     * @request GET:/api/kf-adapter/external/v1/brief-report
     * @secure
     */
    getBriefReport: (query: GetBriefReportParams, params: RequestParams = {}) =>
      this.request<BriefReport, ErrorMessage>({
        path: `/api/kf-adapter/external/v1/brief-report`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
